<template>
  <div v-if="!isCreate && !isLoading" class="chips-product">
    <v-chip v-if="isProduct" class="ma-2 chip-color-product">
      <span>Produto {{ plataform ? plataform : '' }}</span>
    </v-chip>
    <v-chip v-else class="ma-2 chip-color-product-store">
      <span>Produto loja</span>
    </v-chip>
    <v-chip v-if="productForms.manuallyEdited" class="ma-2 chip-color-edit">
      <mf-icon key="1" color="#FF8A00" small fill class="mr-2">border_color</mf-icon>
      <span>Editado</span>
    </v-chip>
    <v-chip v-else-if="productForms.catalogId && productForms.catalogId.length > 0 && $getUseCatalogFlag()" class="ma-2 chip-color-catalog">
      <mf-icon key="2" color="verde-l10" small fill class="mr-2">verified</mf-icon>
      <span>Mercafacil</span>
    </v-chip>
    <v-chip v-else class="ma-2 chip-color-integration">
      <mf-icon key="3" color="marca-0-l40" small fill class="mr-2">store</mf-icon>
      <span>Integração</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'ProductChips',
  components: {},
  props: {
    productForms: {
      type: Object,
      required: true,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isProduct: {
      type: Boolean,
      default: false,
    },
    plataform: {
      type: String,
    },
  },
  data: () => ({}),
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss">
.chips-product {
  .chip-color-catalog {
    background-color: #ccf0d8 !important;
    color: $verde-d20 !important;
    font-weight: 700;
  }
  .chip-color-edit {
    background-color: #f9e2c6 !important;
    color: #cf7000 !important;
    font-weight: 700;
  }
  .chip-color-integration {
    background-color: $marca-0-l90 !important;
    color: $marca-0-l20 !important;
    font-weight: 700;
  }
  .chip-color-product {
    background-color: $marca-0-l90 !important;
    color: $marca-0-l10 !important;
    font-weight: 700;
  }
  .chip-color-product-store {
    background-color: rgba($color: #00d4b1, $alpha: 0.25) !important;
    color: #007d68 !important;
    font-weight: 700;
  }
}
</style>
